export enum InlineDescriptionListDirection {
    Horizontal = 'sh-inline-description-list',
    Vertical = 'sh-inline-description-list--vertical'
}
